import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import authData from "../../services/authData";
import { axiosVal as axios } from "..";
const getToken = () => "Bearer "+localStorage.getItem('auth-token');

const initialState = {
    homeInfo: {},
    requestsCount: {},
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    }
};

export const homeInfoAction = createAsyncThunk('infoSlice/homeInfo', async (requestId) => {
    const response = await axios.get(`info/managerHome`, {
        headers: {
            'x-auth': getToken(),
        },
    });

    return response?.data;
})

export const requestsCountAction = createAsyncThunk('infoSlice/requestsCountAction', async (requestId) => {
    const response = await axios.get(`info/requestsCount`, {
        headers: {
            'x-auth': getToken(),
        },
    });

    return response?.data;
})

const infoSlice = createSlice({
    name: "infoSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(requestsCountAction.fulfilled, (state, action) => {
       
            state.requestsCount = action.payload;
        })
        builder.addCase(homeInfoAction.fulfilled, (state, action) => {
            state.homeInfo = action.payload;
        })
    }
});

export const infoActions = infoSlice.actions;
export const infoReducer = infoSlice.reducer;